import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { DivisionsTableDefinitionZod } from '../../division/tables';
import { CorporationsTableDefinitionZod } from '../tables';

type Arguments = {
    position?: number;
};

export const schemaCorporationResolver_GetOwnCorporation = CorporationsTableDefinitionZod.extend({
    divisions: z.array(DivisionsTableDefinitionZod),
});

export type SchemaCorporationResolver_GetOwnCorporation = z.infer<typeof schemaCorporationResolver_GetOwnCorporation>;

export type CorporationResolver_GetOwnCorporation = Resolver<Arguments, SchemaCorporationResolver_GetOwnCorporation>;
